<!-- <ng-container *ngIf="nextBill">
    <h2 class="title margin-top mt40" [ngClass]="{'dm-sans-medium': !isAcmic}">
        {{ 'NEXT_BILL' | translate }}
    </h2>

    <div class="date-amount margin-right mr16 margin-top mt16">
        <img class="margin-right mr4" src="assets/img/images/icon-calendar.svg" *ngIf="!isAcmic" alt="calendar icon" />
        {{ 'NEXT_AMOUNT_DUE' | translate }} :
        <ng-container>
            <strong>{{ nextBill?.minAmountDue | currency }} </strong>
            <br class="d-block d-md-none" />
            <span>{{ ' on ' }} {{ nextBill?.dateDue | customDateFormat }} </span>
        </ng-container>
    </div>
</ng-container> -->
<div *ngIf="transactions" id="transHistory">
    <div class="bn-transaction-container pt-0">
        <h2 class="title transaction-history" [ngClass]="{'bn-transaction-acmic-history': isAcmic, 'ma-transaction-history-margin': !isAcmic}">
            {{ 'TRANSACTION_HISTORY' | translate }}
        </h2>
       
        <ng-container *ngIf="isAcmic; else maTransactionFilter">
        <form name="transactionFormGroup" [formGroup]="transactionFormGroup" (ngSubmit)="filterTransactions()">
            <div class="margin-bottom mb8 margin-top mt8"
                [ngClass]="{ 'acmic-date-container': isAcmic, 'display-flex align-items-center': isAcmic, 'ios-device': isIOS }">
                <div class="date-fields-row">
                    <div class="input-field mapfre filter-input transaction-date-col start-date date-field-flex"
                        [ngClass]="{ 'acmic-date-flex': isAcmic }">
                        <div class="date-label">Start date</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('fromDate')?.value">
                            <input id="from-date" [ngClass]="{ 'border-required date-input': isAcmic }" name="from-date"
                                type="date" placeholder="mm/dd/yyyy" min="2000-01-01" max="2100-12-31"
                                [formControlName]="'fromDate'" (blur)="compareDates()" (keyup)="compareDates()"
                                (change)="compareDates()" #fromDate />
                            <img src="assets/img/images/icon-calendar-acmic.svg" alt="calendar icon"
                                class="calendar-icon-inside" (click)="openDatePicker('from')" />
                        </div>
                    </div>

                    <div class="input-field mapfre filter-input transaction-date-col end-date date-field-flex"
                        [ngClass]="{ 'acmic-date-flex': isAcmic }">
                        <div class="date-label">End date</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('toDate')?.value">
                            <input id="to-date" [ngClass]="{ 'border-required date-input': isAcmic }" name="to-date"
                                type="date" placeholder="mm/dd/yyyy" min="2000-01-01" max="2100-12-31"
                                [formControlName]="'toDate'" (blur)="compareDates()" (keyup)="compareDates()"
                                (change)="compareDates()" #toDate />
                            <img src="assets/img/images/icon-calendar-acmic.svg" alt="calendar icon"
                                class="calendar-icon-inside" (click)="openDatePicker('to')" />
                        </div>
                    </div>
                </div>

                <div class="filter-button-row">
                    <div class="transaction-date-col submit-date">
                        <mapfre-button [additionalClasses]="' small transaction-filter-b-radius trans-filter-btn'"
                            [translateValue]="'FILTER' | translate"
                            [disabledValue]="transactionFormGroup.valid && buttonEnabled" [inputType]="'submit'">
                            {{ 'FILTER' | translate }}
                        </mapfre-button>
                    </div>
                </div>

            </div>
        </form>
    </ng-container>
    <ng-template #maTransactionFilter>
        <form name="transactionFormGroup" class="" [formGroup]="transactionFormGroup"
            (ngSubmit)="filterTransactions()">
            <div class="ma-date-container" [ngClass]="{'ios-device': isIOS}">
                <div class="date-fields-row">
                    <div class="input-field mapfre filter-input transaction-date-col start-date date-field-flex">
                        <div class="date-label">Start date</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('fromDate')?.value">
                            <input id="from-date" class="date-input" name="from-date" type="date" placeholder="mm/dd/yyyy" min="2000-01-01"
                                max="2100-12-31" [formControlName]="'fromDate'" (blur)="compareDates()"
                                (keyup)="compareDates()" (change)="compareDates()" #fromDate />
                            <label for="from-date" class="translate-calendar-ma"
                                (click)="openDatePicker('from', $event)">
                                <img src="assets/img/images/icon-calendar.svg" alt="calendar icon" />
                            </label>
                        </div>
                    </div>
   
                    <div class="input-field mapfre filter-input transaction-date-col end-date date-field-flex end-date-ma">
                        <div class="date-label">End date</div>
                        <div class="date-input-wrapper" data-placeholder="mm/dd/yyyy"
                            [class.has-value]="transactionFormGroup.get('toDate')?.value">
                            <input id="to-date" class="date-input" name="to-date" type="date" placeholder="mm/dd/yyyy" min="2000-01-01"
                                max="2100-12-31" [formControlName]="'toDate'" (blur)="compareDates()"
                                (keyup)="compareDates()" (change)="compareDates()" #toDate />
                            <label for="to-date" class="translate-calendar-ma"
                                (click)="openDatePicker('to', $event)">
                                <img src="assets/img/images/icon-calendar.svg" alt="calendar icon" />
                            </label>
                        </div>
                    
                    </div>
                </div>
                <div class="align-content-end">
                    <mapfre-button [additionalClasses]="'filter-button'" [translateValue]="'FILTER' | translate"
                        [inputType]="'submit'">
                        {{ 'FILTER' | translate }}
                    </mapfre-button>
                </div>
            </div>
        </form>
    </ng-template>
<!--  -->
<!--  -->
<!--  -->
<!--  -->

    </div>

    <div class="billing-mobile-table payment-table bn-table-transaction-container transaction-table margin-top mt32">
        <table class="table bn-table-stripped billing-table table-striped margin-bottom mb0"
            [ngClass]="{'table-striped-acmic transaction-table-acmic':isAcmic,'margin-bottom mb32':!showLoadTransaction,'table-striped-ma':!isAcmic}">
            <tbody>
                <tr class="row-content heading">
                    <th class="billing-table-col-1" [ngClass]="{'acmic-billing-col-1':isAcmic}">
                        {{ 'Date' | translate }}
                    </th>
                    <th class="billing-table-col-2" [ngClass]="{'acmic-billing-col-2':isAcmic}">
                        {{ 'Description' | translate }}
                    </th>
                    <th class="billing-table-col-3" [ngClass]="{'acmic-billing-col-3':isAcmic}">
                        {{ 'Amount' | translate }}
                    </th>
                    <th class="billing-table-col-4" [ngClass]="{'acmic-billing-col-4':isAcmic}">
                        {{ 'Balance' | translate }}
                    </th>
                </tr>
                <ng-container *ngFor="let transaction of transactions">
                    <tr class="row-content">
                        <td class="billing-table-col-1">
                            {{ transaction?.transactionDate | customDateFormat }}
                        </td>
                        <td class="billing-table-col-2">
                            {{ transaction?.description }}
                        </td>
                        <td class="billing-table-col-3">
                            {{ transaction?.netAmount | currency }}
                        </td>
                        <td class="billing-table-col-4">
                            {{ transaction?.totalBalance | currency }}
                        </td>
                </ng-container>
            </tbody>

        </table>
        <!-- <ng-container *ngIf="!isAcmic && showLoadTransaction"> -->
        <ng-container *ngIf="showLoadTransaction">
            <div (click)="loadTransactions()" class="transaction-load-more"
                [ngClass]="{ 'trans-load-more-acmic': isAcmic, 'mb-4': !isAcmic }">
                {{ "Load more transactions" }}
            </div>
        </ng-container>
    </div>
</div>
